module.exports = __webpack_public_path__ + "static/media/stop.bba9d103.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/peterpan/stop.svg
// module id = 816
// module chunks = 0